import { FunctionComponent, ReactNode, useContext } from 'react'
import styled from 'styled-components'
import contextStandardTeaser from '@contexts/standardTeaser'
import SpecialPromoLine from './SpecialPromoLine'
import PromoLine from './PromoLine'

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledPromoIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const PromoIndicator: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { isInMegaModule } = useContext(StandardTeaserLayoutContext)

  const hasContentOnPromoLine = !isInMegaModule

  return (
    <StyledPromoIndicator>
      {hasContentOnPromoLine ? (
        <SpecialPromoLine>{children}</SpecialPromoLine>
      ) : (
        <PromoLine lineOrientation="top" />
      )}
      <PromoLine lineOrientation="right" />
      <PromoLine lineOrientation="bottom" />
      <PromoLine lineOrientation="left" />
    </StyledPromoIndicator>
  )
}

export default PromoIndicator
